/**
 * Atelier Dwelling - Master Interactive Scripts
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Sticky Nav Blur Effect on Scroll
  const header = document.getElementById('MainHeader') || document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // 2. Scroll Reveal Observer
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealElements.forEach(el => observer.observe(el));
  } else {
    revealElements.forEach(el => el.classList.add('is-visible'));
  }

  // 3. Mobile Navigation Drawer
  const mobileMenuToggle = document.getElementById('MobileMenuToggle');
  const mobileMenuClose = document.getElementById('MobileMenuClose');
  const mobileDrawer = document.getElementById('MobileMenuDrawer');

  function openMobileMenu() {
    if (mobileDrawer) {
      mobileDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileMenu() {
    if (mobileDrawer) {
      mobileDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);

  // 4. Accordion Toggle Logic
  document.querySelectorAll('.accordion-header').forEach(headerBtn => {
    headerBtn.addEventListener('click', () => {
      const item = headerBtn.closest('.accordion-item');
      const content = item ? item.querySelector('.accordion-content') : null;
      const isOpen = item && item.classList.contains('is-open');

      // Optional: Close siblings if grouped
      const group = headerBtn.closest('.accordion-group');
      if (group && !group.dataset.allowMultiple) {
        group.querySelectorAll('.accordion-item').forEach(sibling => {
          if (sibling !== item) {
            sibling.classList.remove('is-open');
            const siblingContent = sibling.querySelector('.accordion-content');
            if (siblingContent) siblingContent.style.maxHeight = null;
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        if (content) content.style.maxHeight = null;
      } else {
        if (item) item.classList.add('is-open');
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // 5. Product Image Gallery Swapper (if thumbnail or click active)
  document.querySelectorAll('[data-gallery-target]').forEach(thumb => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      const targetSrc = thumb.dataset.galleryTarget;
      const mainImage = document.querySelector('.product-main-image');
      if (mainImage && targetSrc) {
        mainImage.src = targetSrc;
      }
      document.querySelectorAll('[data-gallery-target]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // 6. Predictive Search Modal Toggle
  const searchToggle = document.querySelector('[data-action="open-search"]');
  const searchModal = document.getElementById('SearchModal');
  const searchClose = document.getElementById('SearchModalClose');

  if (searchToggle && searchModal) {
    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      searchModal.classList.add('is-open');
      const input = searchModal.querySelector('input[type="search"]');
      if (input) setTimeout(() => input.focus(), 100);
    });
  }

  if (searchClose && searchModal) {
    searchClose.addEventListener('click', () => {
      searchModal.classList.remove('is-open');
    });
  }
});
